import { AxiosResponse } from "axios";
import { GeneralComments } from "../models/general.comments";

import API from "../api";
import BaseService from "./_base.service";

const ROUTE_NAME = "quote-comments";

const QuoteCommentsService = {
  ...BaseService<GeneralComments>({ endpoint: ROUTE_NAME }),
  async createCustomerPortal(
    generalComments: GeneralComments
  ): Promise<AxiosResponse<GeneralComments>> {
    return await API.post(`/${ROUTE_NAME}/customer-portal`, generalComments);
  },
  async deleteCustomerPortal(id: number): Promise<AxiosResponse<GeneralComments>> {
    return await API.delete(`/${ROUTE_NAME}/customer-portal/${id}`);
  },
};

export default QuoteCommentsService;
